import {Mapper} from '@s-ui/domain'

export class FromSearchParamsToStatsRequestVOMapper extends Mapper {
  constructor({statsRequestVOFactory, config}) {
    super()

    this._statsRequestVOFactory = statsRequestVOFactory
    this._config = config
  }

  getVehicles(initialVehiclesFilter) {
    const firstVehicle = initialVehiclesFilter[0]

    return [
      {
        makeId: firstVehicle.makeId,
        modelId: firstVehicle.model.id,
        model: firstVehicle.model.name
      }
    ]
  }

  getPricesAggregation() {
    return {
      name: 'avgPrices',
      field: 'price',
      function: 'avg'
    }
  }

  getKmAggregation() {
    return {
      name: 'avgKms',
      field: 'km',
      function: 'avg'
    }
  }

  getYearsAggregation({filters}) {
    const {year} = filters
    if (year.from || year.to) return null

    return {
      name: 'avgYears',
      field: 'year',
      function: 'avg'
    }
  }

  getConsumptionAggregation({filters}) {
    const {FUEL_TYPE_ELECTRIC_ID, FUEL_TYPE_GLP_ID, FUEL_TYPE_CNG_ID} = this._config.get('search')

    if (
      filters.fuelTypeIds.includes(FUEL_TYPE_ELECTRIC_ID) ||
      filters.fuelTypeIds.includes(FUEL_TYPE_GLP_ID) ||
      filters.fuelTypeIds.includes(FUEL_TYPE_CNG_ID)
    )
      return null

    return {
      name: 'avgConsumption',
      field: 'mixedConsumption',
      function: 'avg'
    }
  }

  getColorAggregation() {
    return {
      name: 'avgColor',
      field: 'color',
      function: 'most_freq'
    }
  }

  getFuelAggregation({filters}) {
    if (filters.fuelTypeIds.length) return null

    return {
      name: 'FuelType',
      field: 'fuelType',
      function: 'most_freq'
    }
  }

  getAggregations({filters}) {
    const aggregrationsCollection = [
      this.getPricesAggregation(),
      this.getKmAggregation(),
      this.getYearsAggregation({filters}),
      this.getConsumptionAggregation({filters}),
      this.getColorAggregation(),
      this.getFuelAggregation({filters})
    ]

    return aggregrationsCollection.filter(aggregation => aggregation)
  }

  getPagination() {
    return {size: 1, page: 1}
  }

  map = ({filters}) => {
    const {fuelTypeIds, year} = filters
    const adaptedFilters = {
      vehicles: this.getVehicles(filters.vehicles),
      fuelTypeIds,
      year
    }

    return this._statsRequestVOFactory({
      filters: adaptedFilters,
      aggregations: this.getAggregations({filters}),
      pagination: this.getPagination()
    })
  }
}
